import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '@/components/ui/LanguageSwitcher/index.ts'
import { useAlert } from '@/hooks/useAlert.ts'
import { Button } from '@/components/ui/Button/index.ts'

export function SettingsPage() {
  const { t } = useTranslation()
  const { showAlert } = useAlert()

  const handleSave = () => {
    showAlert({ type: 'success', message: t('alerts.success') })
  }

  return (
    <div className="max-w-content mx-auto px-4 py-8 md:px-8 md:py-12">
      <h1 className="text-fg mb-8 text-[1.75rem] font-bold max-md:text-[1.375rem]">
        {t('settings.title')}
      </h1>

      <div className="border-line bg-gradient-card mb-6 rounded-xl border p-6">
        <div className="flex items-center justify-between gap-4 max-md:flex-col max-md:items-start">
          <span className="text-fg font-medium">{t('settings.language')}</span>
          <LanguageSwitcher />
        </div>
      </div>

      <Button onClick={handleSave}>{t('common.save')}</Button>
    </div>
  )
}
